import React from 'react';
import isString from 'lodash/isString';

import { makeStyles } from 'design-system/styles';
import QMSelectProjectPage from './QMSelectProjectPage';

const useStyles = makeStyles({
  container: {
    marginTop: 40,
    margin: '0 auto',
    textAlign: 'center',
  },
  selectProject: {
    marginTop: 20,
    textAlign: 'left',
  },
});

enum ErrorType {
  InvalidProjectId,
  Unknown,
}

function errorType(error: unknown): ErrorType {
  const chunk = getErrorMessage(error).split('"');

  // determine if the cause for error is invalid project id
  // there is no error type in the response so we do a kludgy error message parse
  // e.g. chunk = ["Cast to ObjectId failed for value ", "5",
  //               " at path ", "_id", " for model ", "project", ""]
  if (chunk && chunk.length === 7 && chunk[3] === '_id') {
    return ErrorType.InvalidProjectId;
  }

  return ErrorType.Unknown;
}

const QMErrorPage: React.FC<{ className?: string; title?: string; error: unknown }> = ({
  error,
  title,
  className,
}) => {
  const classes = useStyles();
  const actualTitle = title || 'Sorry there was a problem.';

  // prompt the user to select a new project if an invalid project_id is passed to url
  if (errorType(error) === ErrorType.InvalidProjectId) {
    return <QMSelectProjectPage />;
  }

  return (
    <div className={[className, classes.container].join(' ')}>
      <h1>{actualTitle}</h1>
      <div>{getErrorMessage(error)}</div>
    </div>
  );
};

function getErrorMessage(error: unknown): string {
  if (isAPIFetchError(error)) {
    return error.response.error;
  } else if (error instanceof Error) {
    return error.message;
  } else {
    return 'unknown error';
  }
}

interface APIFetchError {
  response: {
    error: string;
  };
}

function isAPIFetchError(error: unknown): error is APIFetchError {
  return isString((error as APIFetchError)?.response?.error);
}

export default QMErrorPage;
